import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { AiReportSummary, AiReportSummaryStatus, AiReportSummaryStatusResponse } from 'src/app/models/ai-report-summary';
import { ApiModelService } from '../sp-api-model/api-model.service';
import { LoggerService } from '../../sp-logger/logger.service';

// Interface to match your backend response
interface SummaryResponse {
  project_id: string;
  text_output: string;
  status: AiReportSummaryStatus;
  type: string;
  remaining_seconds: number | null;
}

@Injectable({
  providedIn: 'root'
})

export class ApiAiReportSummaryService extends ApiModelService<AiReportSummary> {
  protected readonly basePath = 'projects';
  private readonly endpoint = 'ai-report-summaries';

  constructor(http: HttpClient, logger: LoggerService) { 
    super(http, logger);
  }

  generateAiReportSummary(projectId: number, type: string) {
    return firstValueFrom(this.post(`${this.basePath}/${projectId}/${this.endpoint}`, {type}));
  }

  refreshAiReportSummary(projectId: number, type: string) {
    return firstValueFrom(this.put(`${this.basePath}/${projectId}/${this.endpoint}`, {type}));
  }

  async getAiReportSummary(projectId: number, type: string): Promise<AiReportSummary> {
    const response = await firstValueFrom(
      this.get<SummaryResponse>(`${this.basePath}/${projectId}/${this.endpoint}`, {type})
    );
    const insightsSummary: AiReportSummary = {
      id: 0, 
      project_id: projectId,
      text_output: response.text_output || '',
      status: response.status,
      remaining_seconds: response.remaining_seconds,
      type: response.type
    };

    return insightsSummary;
  }

  async canCreateAiReportSummary(projectId: number): Promise<boolean> {
    const response = await firstValueFrom(
      this.get<{can_create: boolean}>(`${this.basePath}/${projectId}/${this.endpoint}/can-create`)
    );
    return response.can_create;
  }

 
  
}
